import state from './profilePostsState'
import mutations from './profilePostsMutations'
import getters from './profilePostsGetters'
import actions from './profilePostsActions'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
